export default "__VITE_ASSET__DCpBIlbB__"